export default __webpack_public_path__ + "static/insights-tab-64b8ca62a738d29138797e0507ae307d.svg";